const sizeConfigs = {
  sidebar: {
    width: "350px"
  },
  topbar: {
    height: "50px"
  },
  footer: {
    height: "0px" //TODO remettre 40px quand le footer sera réactivé
  }
};

export default sizeConfigs;